module.exports = __webpack_public_path__ + "3a361e0cd98bfc2cda0aee79460d4ec8.MP3";